var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer d-flex align-items-center justify-content-center"},[_c('div',{},[_c('span',{staticClass:"leyenda_footer"},[_vm._v("B312 Studio | "+_vm._s(_vm.fecha)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }